import { FC } from "react";

export const IconLock: FC = () => (
  <svg
    viewBox="0 0 33 33"
    fill="none"
    stroke="currentColor"
    strokeWidth="3"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M24.8333 14.8333V9.83333C24.8333 5.23096 21.1024 1.5 16.5 1.5C11.8976 1.5 8.16667 5.23096 8.16667 9.83333V14.8333M9.5 31.5H23.5C26.3003 31.5 27.7004 31.5 28.77 30.955C29.7108 30.4757 30.4757 29.7108 30.955 28.77C31.5 27.7004 31.5 26.3003 31.5 23.5V22.8333C31.5 20.0331 31.5 18.6329 30.955 17.5634C30.4757 16.6226 29.7108 15.8577 28.77 15.3783C27.7004 14.8333 26.3003 14.8333 23.5 14.8333H9.5C6.69974 14.8333 5.29961 14.8333 4.23005 15.3783C3.28924 15.8577 2.52434 16.6226 2.04497 17.5634C1.5 18.6329 1.5 20.0331 1.5 22.8333V23.5C1.5 26.3003 1.5 27.7004 2.04497 28.77C2.52434 29.7108 3.28924 30.4757 4.23005 30.955C5.29961 31.5 6.69974 31.5 9.5 31.5Z" />
  </svg>
);

export default IconLock;
